import { gql } from '@apollo/client'

export const TRAINING_POINT_CLOUD_FRAGMENT = gql`
  fragment TrainingPointCloud on TrainingPointCloud {
    __typename
    id
    labels
    centroids
    predicted
    bucketFileName
    saved
    created
    metadata
  }
`
